import { useState } from "react";
import { useRouter } from "next/router";
import { parseQueryPageNumber } from "src/utils/helpers/requestApi/parseQueryPageNumber";
import { isStringQuery } from "src/utils/helpers/url/isStringQuery";
import { CategoryMainSectionSchema } from "src/models/categoryBrand/types";
import { getCategoryBrand } from "src/models/categoryBrand/getCategoryBrand";
import { CATEGORIES_FILTER_OPTION } from "src/components/BrandCategoryPage/components/MainBrandSection/components/MainSection/ProductList/PriceSort";
import { FilterFields } from "src/components/BrandCategoryPage/components/MainBrandSection/components/Filters/FiltersList";

export interface RequestParams {
  filters?: FilterFields;
  sort?: CATEGORIES_FILTER_OPTION;
  pageNumber?: number;
}

export const useCategoryBrand = (
  categoryBrandData: CategoryMainSectionSchema,
  filterOption: CATEGORIES_FILTER_OPTION
) => {
  const [isLoading, setLoading] = useState<boolean>(false);

  const [data, setData] =
    useState<CategoryMainSectionSchema>(categoryBrandData);

  const {
    query: { city, categoryBrand },
    push,
  } = useRouter();

  const currentPage =
    Array.isArray(categoryBrand) && categoryBrand[1]
      ? parseQueryPageNumber(categoryBrand[1])
      : 1;

  const changePageHref = (isDesc: boolean) => (pageNumber: number) => {
    return {
      pathname: "/[city]/category/[...categoryBrand]",
      query: {
        city,
        categoryBrand: [
          categoryBrand?.[0] || "",
          pageNumber !== 1
            ? `page-${pageNumber}${isDesc ? "-desc" : ""}`
            : isDesc
            ? "desc"
            : "",
        ],
      },
    };
  };

  const requestCategoryBrand = ({
    sort,
    filters,
    pageNumber,
  }: RequestParams) => {
    setLoading(true);
    if (isStringQuery(city) && Array.isArray(categoryBrand)) {
      const currentSortingType = sort || filterOption;

      getCategoryBrand({
        page: pageNumber || 1,
        brand_slug: categoryBrand[0],
        city_slug: city,
        order_by_price_asc:
          CATEGORIES_FILTER_OPTION.PriceIncrease === currentSortingType,
        dosage_filter_list: filters?.dosages,
        form_filter_list: filters?.forms,
        packaging_filter_list: filters?.packagins,
        min_price_filter: filters?.priceFilter?.[0],
        max_price_filter: filters?.priceFilter?.[1],
      })
        .then((res) => setData(res.data.main_section))
        .catch((error) => console.log(error))
        .finally(() => setLoading(false));

      push(
        changePageHref(
          CATEGORIES_FILTER_OPTION.PriceDecrease === currentSortingType
        )(pageNumber || 1),
        undefined,
        { shallow: true }
      );
    }
  };

  return {
    data,
    currentPage,
    changePageHref,
    isLoading,
    requestCategoryBrand,
  };
};
